import { Component, Input, OnInit } from '@angular/core';
import { CustomerAndAddressHeader } from 'src/app/models/customer-address/customer-and-address-header';
import { ResponseGetQuoteCopyHeader } from 'src/app/models/quote/response-get-quote-copy-header';
import { ResponseRecommendationCopyHeader } from 'src/app/models/recommendation/response-recommendation-copy-header';
import { SurveyProspectCustomerHeaderDetails } from 'src/app/models/survey-customer-address/survey-prospect-customer-header-details';

@Component({
  selector: 'app-customer-and-address-card',
  templateUrl: './customer-and-address-card.component.html',
  styleUrls: ['./customer-and-address-card.component.scss'],
})
export class CustomerAndAddressCardComponent implements OnInit {

  @Input() header: CustomerAndAddressHeader | SurveyProspectCustomerHeaderDetails | ResponseRecommendationCopyHeader | ResponseGetQuoteCopyHeader;

  constructor() { }

  ngOnInit() {}

}
